import { cn } from "@/lib/cn";

interface BarRow {
  label: string;
  value: number;
  /** optional secondary text shown right-aligned (e.g. formatted money). */
  display?: string;
  tone?: string; // CSS color value
}

/** Horizontal labelled bars — A/R aging, top customers. Tabular by design. */
export function BarMeter({
  rows,
  className,
}: {
  rows: BarRow[];
  className?: string;
}) {
  const max = Math.max(...rows.map((r) => r.value), 1);
  return (
    <div className={cn("flex flex-col gap-2.5", className)}>
      {rows.map((r) => (
        <div key={r.label} className="grid grid-cols-[5.5rem_1fr_auto] items-center gap-3">
          <span className="truncate text-xs text-ink-soft">{r.label}</span>
          <span className="h-2 overflow-hidden rounded-full bg-sunken">
            <span
              className="block h-full rounded-full transition-[width] duration-500"
              style={{
                width: `${Math.max(2, (r.value / max) * 100)}%`,
                background: r.tone ?? "var(--color-brand)",
              }}
            />
          </span>
          <span className="font-mono tabular text-xs text-ink">{r.display ?? r.value}</span>
        </div>
      ))}
    </div>
  );
}
